import React, { SVGProps } from 'react'
export const ShareSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5 8.202a3.333 3.333 0 0 0-3.333 3.333v3.333A3.333 3.333 0 0 0 5 18.202h10a3.333 3.333 0 0 0 3.333-3.334v-3.333A3.333 3.333 0 0 0 15 8.202h-1.667a2.5 2.5 0 0 0-2.5 2.5v.833a.833.833 0 0 1-1.667 0v-.833a2.5 2.5 0 0 0-2.5-2.5H5Z"
    />
    <path
      fill="currentColor"
      d="M11.646 2.285a2.5 2.5 0 0 0-3.292 0L6.118 4.241a.833.833 0 0 0 1.097 1.255l1.952-1.708v3.58a.833.833 0 0 0 1.666 0v-3.58l1.951 1.708a.833.833 0 1 0 1.098-1.255l-2.236-1.956Z"
    />
  </svg>
)
